module.exports = "<div ng-mousedown=\"vm.startDurationDrag($event)\" class=\"duration-dragger\"></div>";